var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.625 6a4.625 4.625 0 1 1-9.25 0 4.625 4.625 0 0 1 9.25 0m1 0A5.625 5.625 0 1 1 .375 6a5.625 5.625 0 0 1 11.25 0M6 2.5a.5.5 0 0 1 .5.5v2.5H9a.5.5 0 0 1 0 1H6.5V9a.5.5 0 0 1-1 0V6.5H3a.5.5 0 0 1 0-1h2.5V3a.5.5 0 0 1 .5-.5",
    clipRule: "evenodd"
  })));
});
const SvgAddCirclesmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddCirclesmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC42MjUgNkMxMC42MjUgOC41NTQzMiA4LjU1NDMyIDEwLjYyNSA2IDEwLjYyNUMzLjQ0NTY4IDEwLjYyNSAxLjM3NSA4LjU1NDMyIDEuMzc1IDZDMS4zNzUgMy40NDU2OCAzLjQ0NTY4IDEuMzc1IDYgMS4zNzVDOC41NTQzMiAxLjM3NSAxMC42MjUgMy40NDU2OCAxMC42MjUgNlpNMTEuNjI1IDZDMTEuNjI1IDkuMTA2NiA5LjEwNjYgMTEuNjI1IDYgMTEuNjI1QzIuODkzNCAxMS42MjUgMC4zNzUgOS4xMDY2IDAuMzc1IDZDMC4zNzUgMi44OTM0IDIuODkzNCAwLjM3NSA2IDAuMzc1QzkuMTA2NiAwLjM3NSAxMS42MjUgMi44OTM0IDExLjYyNSA2Wk02IDIuNTAwMDVDNi4yNzYxNCAyLjUwMDA1IDYuNSAyLjcyMzkgNi41IDMuMDAwMDVWNS41SDlDOS4yNzYxNCA1LjUgOS41IDUuNzIzODYgOS41IDZDOS41IDYuMjc2MTQgOS4yNzYxNCA2LjUgOSA2LjVINi41VjkuMDAwMDVDNi41IDkuMjc2MTkgNi4yNzYxNCA5LjUwMDA1IDYgOS41MDAwNUM1LjcyMzg2IDkuNTAwMDUgNS41IDkuMjc2MTkgNS41IDkuMDAwMDVWNi41SDNDMi43MjM4NiA2LjUgMi41IDYuMjc2MTQgMi41IDZDMi41IDUuNzIzODYgMi43MjM4NiA1LjUgMyA1LjVINS41VjMuMDAwMDVDNS41IDIuNzIzOSA1LjcyMzg2IDIuNTAwMDUgNiAyLjUwMDA1WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";